import { useState, useEffect } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { GoogleLogin } from '@react-oauth/google'
import './Login.css'

function Login() {
    const [loading, setLoading] = useState(false)
    const [erro, setErro] = useState('')
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { loginGoogle } = useAuth()

    useEffect(() => {
        if (searchParams.get('sessao_expirada') === 'true') {
            setErro('Sua sessão expirou por segurança. Por favor, faça login novamente.')
        }
    }, [searchParams])

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <Link to="/" className="auth-logo">
                            <img src="/logo/agroov-completa.jpg" alt="Agroov" style={{ maxWidth: '180px', height: 'auto', marginBottom: '1.5rem', borderRadius: 'var(--radius-md)' }} />
                        </Link>
                        <h1>Entrar</h1>
                        <p>Acesse sua conta no Agroov</p>
                    </div>

                    {erro && (
                        <div className="alert alert-error">
                            {erro}
                        </div>
                    )}

                    <div className="auth-social" style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '1.5rem' }}>
                        <GoogleLogin
                            onSuccess={async (credentialResponse) => {
                                try {
                                    setLoading(true)
                                    await loginGoogle(credentialResponse.credential)
                                    navigate('/')
                                } catch (error) {
                                    setErro(error.message || 'Erro no login com o Google')
                                } finally {
                                    setLoading(false)
                                }
                            }}
                            onError={() => {
                                setErro('Falha na autenticação com o Google')
                            }}
                            useOneTap
                            theme="filled_blue"
                            shape="pill"
                            locale="pt_BR"
                        />
                    </div>

                    {loading && (
                        <div style={{ textAlign: 'center', marginTop: '1rem', color: 'var(--color-text-secondary)' }}>
                            Entrando...
                        </div>
                    )}

                    <div className="auth-footer">
                        <p>
                            Não tem uma conta?{' '}
                            <Link to="/cadastro">Cadastre-se grátis</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login
